@for (e of viewModel; track e) {
    @if (getMessage(e); as message) {
        <bs-alert [message]="message" [title]="getTitle(e)" [type]="getType(e)" (click)="redirectFromErrorMessage($event)" />
    }
}
